var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 417.68,
    style: {
      fill: "#4173CD"
    },
    width: 512,
    height: 94.32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4173CD"
    },
    width: 512,
    height: 94.32
  })), /*#__PURE__*/React.createElement("rect", {
    y: 94.32,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 323.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 80.84,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 26.947
  }), /*#__PURE__*/React.createElement("rect", {
    y: 404.21,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 26.947
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M452.365,264.794H59.074c-2.375,0-4.3-1.925-4.3-4.3v-2.564c0-2.375,1.925-4.3,4.3-4.3h393.291   c2.375,0,4.3,1.925,4.3,4.3v2.564C456.665,262.869,454.739,264.794,452.365,264.794z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "375.728,242.467 395.265,234.094 414.801,242.467 395.265,250.839 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M380.535,238.9H93.847c-1.97,0-3.566,1.597-3.566,3.566s1.597,3.566,3.566,3.566h286.688  c1.97,0,3.566-1.597,3.566-3.566C384.101,240.497,382.504,238.9,380.535,238.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "396.04,222.93 415.576,214.557 435.113,222.93 415.576,231.303 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M400.846,219.364H114.158c-1.97,0-3.566,1.597-3.566,3.566s1.597,3.566,3.566,3.566h286.688  c1.97,0,3.566-1.597,3.566-3.566C404.413,220.961,402.816,219.364,400.846,219.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M255.719,186.648c-49.577,0-92.831,28.075-115.997,69.773c23.166,41.698,66.42,69.773,115.997,69.773  s92.831-28.075,115.997-69.773C348.55,214.723,305.296,186.648,255.719,186.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M139.722,256.421c23.166,41.698,66.42,69.773,115.997,69.773c8.279,0,16.359-0.85,24.221-2.348  c-6.003-13.176-27.113-13.153-28.408-18.119c-1.395-5.349,17.21-4.186,20.467-8.605c3.256-4.419-17.676-6.28-18.606-10.698  c-0.93-4.419,8.373-7.443,10.001-14.42s5.349-9.07,8.14-13.257c2.791-4.186-4.651-5.582-6.512-19.536  c-1.861-13.955-12.792-15.815-18.141-27.211c-5.349-11.396,3.256-19.769,8.838-25.351  C206.143,186.648,162.888,214.723,139.722,256.421z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.16,
    y: 231.3,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.32,
    y: 231.3,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.48,
    y: 231.3,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.65,
    y: 231.3,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 231.3,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.97,
    y: 231.3,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.16,
    y: 264.79,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.32,
    y: 264.79,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.48,
    y: 264.79,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.65,
    y: 264.79,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 264.79,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.97,
    y: 264.79,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.582,
    height: 22.327
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.88,
    y: 231.3,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.05,
    y: 231.3,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.21,
    y: 231.3,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.37,
    y: 231.3,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.54,
    y: 231.3,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.7,
    y: 231.3,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.88,
    y: 264.79,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.05,
    y: 264.79,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.21,
    y: 264.79,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.37,
    y: 264.79,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.54,
    y: 264.79,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.7,
    y: 264.79,
    style: {
      fill: "#464655"
    },
    width: 5.582,
    height: 22.327
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#245DBD"
    },
    d: "M427.963,252.758c-4.47,10.385-17.191,11.606-10.143,38.077l3.61-3.665  c0,0,3.782,9.977,12.893,16.697c0,0,11.174-9.366,12.034-24.231l4.642,2.036C450.999,281.672,448.764,254.591,427.963,252.758z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M444.466,274.036c-0.357,0-0.712-0.165-0.98-0.49c-4.378-5.281-9.955-6.974-10.008-6.993   c-0.736-0.216-1.187-1.101-1.005-1.973c0.183-0.865,0.929-1.406,1.663-1.19c0.258,0.076,6.369,1.915,11.311,7.878   c0.532,0.636,0.524,1.673-0.016,2.303C445.162,273.884,444.815,274.036,444.466,274.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M441.315,286.355c-0.411,0-0.819-0.216-1.091-0.636c-3.247-5.001-6.93-7.725-6.968-7.75   c-0.647-0.471-0.846-1.476-0.449-2.246c0.4-0.764,1.246-0.999,1.894-0.528c0.169,0.121,4.153,3.073,7.704,8.539   c0.462,0.713,0.349,1.737-0.253,2.284C441.904,286.247,441.608,286.355,441.315,286.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M434.098,300.068c-0.078,0-0.156-0.006-0.236-0.025c-0.747-0.153-1.252-0.993-1.123-1.877   c0.543-3.729,0.089-9.844-0.655-13c-0.204-0.865,0.223-1.763,0.954-2.011c0.739-0.235,1.491,0.267,1.695,1.133   c0.841,3.563,1.332,10.213,0.72,14.425C435.336,299.508,434.753,300.068,434.098,300.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M424.425,285.025c-0.392,0-0.782-0.197-1.053-0.579c-0.489-0.687-0.416-1.718,0.164-2.297   c0.035-0.032,3.546-3.595,4.462-8.527c0.164-0.878,0.892-1.432,1.639-1.241c0.741,0.191,1.211,1.063,1.048,1.941   c-1.123,6.032-5.203,10.149-5.378,10.321C425.048,284.898,424.737,285.025,424.425,285.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M420.605,274.603c-0.462,0-0.913-0.274-1.174-0.776c-0.398-0.764-0.196-1.769,0.451-2.24   c0.051-0.038,5.039-3.71,6.586-7.718c0.314-0.827,1.136-1.19,1.824-0.808c0.69,0.375,0.994,1.343,0.68,2.157   c-1.899,4.919-7.416,8.972-7.65,9.144C421.097,274.526,420.85,274.603,420.605,274.603z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#245DBD"
    },
    d: "M79.452,256.253c-3.737,8.683-14.375,9.705-8.481,31.839l3.019-3.065c0,0,3.162,8.343,10.781,13.961  c0,0,9.344-7.832,10.062-20.261l3.881,1.703C98.714,280.431,96.846,257.786,79.452,256.253z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M93.252,274.046c-0.299,0-0.595-0.138-0.82-0.41c-3.661-4.416-8.324-5.831-8.369-5.847   c-0.615-0.181-0.993-0.921-0.84-1.649c0.153-0.724,0.777-1.176,1.39-0.995c0.216,0.064,5.325,1.602,9.458,6.587   c0.445,0.532,0.438,1.399-0.013,1.926C93.834,273.918,93.544,274.046,93.252,274.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M90.617,284.347c-0.344,0-0.685-0.181-0.912-0.532c-2.715-4.182-5.795-6.459-5.826-6.481   c-0.541-0.394-0.708-1.234-0.375-1.878c0.335-0.638,1.042-0.835,1.583-0.442c0.142,0.101,3.472,2.57,6.442,7.14   c0.386,0.596,0.292,1.453-0.211,1.91C91.109,284.256,90.862,284.347,90.617,284.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M84.582,295.813c-0.065,0-0.13-0.005-0.198-0.021c-0.624-0.128-1.047-0.83-0.939-1.57   c0.454-3.118,0.074-8.231-0.548-10.87c-0.171-0.724,0.186-1.474,0.797-1.681c0.618-0.197,1.247,0.223,1.417,0.947   c0.703,2.98,1.114,8.54,0.602,12.062C85.617,295.345,85.13,295.813,84.582,295.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M76.494,283.235c-0.328,0-0.654-0.165-0.88-0.484c-0.409-0.575-0.348-1.437,0.137-1.921   c0.029-0.027,2.965-3.006,3.731-7.13c0.137-0.734,0.746-1.197,1.37-1.038c0.62,0.16,1.013,0.889,0.876,1.623   c-0.939,5.044-4.351,8.486-4.497,8.63C77.015,283.128,76.754,283.235,76.494,283.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M73.3,274.519c-0.386,0-0.764-0.229-0.982-0.649c-0.332-0.638-0.164-1.479,0.377-1.873   c0.043-0.032,4.214-3.102,5.507-6.454c0.263-0.692,0.95-0.995,1.525-0.676c0.577,0.314,0.831,1.123,0.568,1.804   c-1.588,4.113-6.201,7.502-6.397,7.646C73.711,274.456,73.504,274.519,73.3,274.519z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.28ff6978f4d2b87d31f2a4deb5e00e52.svg";
export { ForwardRef as ReactComponent };